import CustomRadioGroup from "../organism/custom-radio-group.organism";
import { normalizeOptions } from "../../utils/generalFormUtils";

const InputRadioGroup = ({ question, answer, onAnswerChange, id }) => {
  const options = normalizeOptions(question.options);
  const selectedValue = answer ?? null;

  return (
    <CustomRadioGroup
      label={question.label || "Pregunta sin título"}
      options={options}
      selectedValue={selectedValue}
      onChange={onAnswerChange}
      id={`question-${id}`}
    />
  );
};

export default InputRadioGroup;
